import normalizeAttributeGroups from '../shared/helpers/normalizeAttributeGroups';


export default function (product) {
  const attributes = normalizeAttributeGroups(product);
  const productWithUpdatedAttributes = {
    ...product,
    ...attributes,
  };

  return productWithUpdatedAttributes;
}
